import { TEMPTED_BACKEND } from '../../../../../../../../constants/apiUrls/apiUrls';


export async function getVideo(anchorId, videoId) {
  const createHeaders = () => {
    const obj = { username: '', Authorization: '' };
    if (sessionStorage.getItem('username')) {
      obj.username = sessionStorage.getItem('username');
    }
    if (sessionStorage.getItem('token')) {
      obj.Authorization = `Bearer ${sessionStorage.getItem('token')}`;
    }

    return obj;
  };

  const response = await fetch(`${TEMPTED_BACKEND}/rest/v1/anchor/${anchorId}/privateContent/video/${videoId}`, { headers: createHeaders() });

  if (response) {
    const json = await response.json();

    if (json && json.temporaryUrl) {
      return json.temporaryUrl;
    }
  }

  return null;
}
